import React, { useState, useMemo } from "react";
import {
  AllCommunityModule,
  ModuleRegistry,
  ValidationModule,
} from "ag-grid-community";
// Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@/App.css";
import { AgGridReact } from "ag-grid-react";

ModuleRegistry.registerModules([AllCommunityModule]);
if (import.meta.env.NODE_ENV !== "production") { // Se usa solo en desarrollo para evitar aumentar el tamaño del bundle en producción
  ModuleRegistry.registerModules([ValidationModule]);
}

export default function DataTableStaff() {
  // Sample data based on the reference image
  const [rowData] = useState([
    {
      id: 1,
      nombre: "Christopher Ferrada",
      instagram: "crisferrada",
      totalControl: 629,
      invitacionFree: 450,
      invitacionConDescuento: 0,
      controlPagado: 179,
      comision: 1250000,
      estado: "aprovado",
    },
    {
      id: 2,
      nombre: "Raphael Goodman",
      instagram: "raphael.g",
      totalControl: 509,
      invitacionFree: 350,
      invitacionConDescuento: 0,
      controlPagado: 209,
      comision: 3200,
      estado: "pendiente",
    },
    {
      id: 3,
      nombre: "Ludwig Contessa",
      instagram: "BKG12347",
      totalControl: 450,
      invitacionFree: 400,
      invitacionConDescuento: 0,
      controlPagado: 50,
      comision: 2100,
      estado: "confirmado",
    },
    {
      id: 4,
      nombre: "Armina Raul Meyes",
      instagram: "BKG12348",
      totalControl: 425,
      invitacionFree: 400,
      invitacionConDescuento: 0,
      controlPagado: 25,
      comision: 2800,
      estado: "cancelado",
    },
    {
      id: 5,
      nombre: "James Dunn",
      instagram: "BKG12349",
      totalControl: 400,
      invitacionFree: 340,
      invitacionConDescuento: 0,
      controlPagado: 60,
      comision: 1200,
      estado: "confirmado",
    },
    {
      id: 6,
      nombre: "Hillary Grey",
      instagram: "BKG12350",
      totalControl: 350,
      invitacionFree: 300,
      invitacionConDescuento: 0,
      controlPagado: 50,
      comision: 1800,
      estado: "confirmado",
    },
    {
      id: 7,
      nombre: "Lucas Oconnor",
      instagram: "BKG12351",
      totalControl: 300,
      invitacionFree: 280,
      invitacionConDescuento: 0,
      controlPagado: 20,
      comision: 2500,
      estado: "pendiente",
    },
    {
      id: 8,
      nombre: "Layla Linch",
      instagram: "BKG12352",
      totalControl: 250,
      invitacionFree: 185,
      invitacionConDescuento: 0,
      controlPagado: 65,
      comision: 1600,
      estado: "confirmado",
    },
    {
      id: 9,
      nombre: "Marcus Johnson",
      instagram: "BKG12353",
      totalControl: 200,
      invitacionFree: 145,
      invitacionConDescuento: 0,
      controlPagado: 55,
      comision: 1400,
      estado: "confirmado",
    },
    {
      id: 10,
      nombre: "Sofia Martinez",
      instagram: "BKG12354",
      totalControl: 185,
      invitacionFree: 150,
      invitacionConDescuento: 0,
      controlPagado: 35,
      comision: 1600,
      estado: "pendiente",
    },
    {
      id: 11,
      nombre: "Ethan Brown",
      instagram: "BKG12355",
      totalControl: 175,
      invitacionFree: 130,
      invitacionConDescuento: 0,
      controlPagado: 45,
      comision: 1500,
      estado: "confirmado",
    },
    {
      id: 12,
      nombre: "Olivia Wilson",
      instagram: "BKG12356",
      totalControl: 160,
      invitacionFree: 120,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 1400,
      estado: "pendiente",
    },
    {
      id: 13,
      nombre: "Mason Davis",
      instagram: "BKG12357",
      totalControl: 150,
      invitacionFree: 100,
      invitacionConDescuento: 0,
      controlPagado: 50,
      comision: 1300,
      estado: "confirmado",
    },
    {
      id: 14,
      nombre: "Ava Garcia",
      instagram: "BKG12358",
      totalControl: 140,
      invitacionFree: 100,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 1200,
      estado: "pendiente",
    },
    {
      id: 15,
      nombre: "Logan Miller",
      instagram: "BKG12359",
      totalControl: 130,
      invitacionFree: 90,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 1100,
      estado: "pendiente",
    },
    {
      id: 16,
      nombre: "Isabella Martinez",
        instagram: "BKG12360",
      totalControl: 120,
      invitacionFree: 80,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 1000,
      estado: "pendiente",
    },
    {
      id: 17,
      nombre: "Lucas Anderson",
      instagram: "BKG12361",
      totalControl: 110,
      invitacionFree: 70,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 900,
      estado: "pendiente",
    },
    {
      id: 18,
      nombre: "Mia Thomas",
      instagram: "BKG12362",
      totalControl: 100,
      invitacionFree: 60,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 800,
      estado: "pendiente",
    },
    {
      id: 19,
      nombre: "Liam Smith",
      instagram: "BKG12363",
      totalControl: 90,
      invitacionFree: 50,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 700,
      estado: "pendiente",
    },
    {
      id: 20,
      nombre: "Emma Wilson",
      instagram: "BKG12364",
      totalControl: 80,
      invitacionFree: 40,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 600,
      estado: "pendiente",
    },
    {
        id: 21,
        nombre: "James Taylor",
        instagram: "BKG12365",
        totalControl: 70,
        invitacionFree: 30,
        invitacionConDescuento: 0,
        controlPagado: 40,
        comision: 500,
        estado: "pendiente",
    },
    {
      id: 22,
      nombre: "Sophia Johnson",
      instagram: "BKG12366",
      totalControl: 60,
      invitacionFree: 20,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 400,
      estado: "pendiente",
    },
    {
      id: 23,
      nombre: "William Brown",
      instagram: "BKG12367",
      totalControl: 50,
      invitacionFree: 10,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 300,
      estado: "pendiente",
    },
    {
      id: 24,
      nombre: "Olivia Wilson",
      instagram: "BKG12368",
      totalControl: 40,
      invitacionFree: 0,
      invitacionConDescuento: 0,
      controlPagado: 40,
      comision: 200,
      estado: "pendiente",
    },
    {
      id: 25,
      nombre: "James Smith",
      instagram: "BKG12369",
      totalControl: 30,
      invitacionFree: 0,
      invitacionConDescuento: 0,
      controlPagado: 30,
      comision: 100,
      estado: "pendiente",
    },
  ]);

  // Status badge select renderer
  const StatusCellRenderer = (params) => {
    const status = params.value;
    let bgColor = "bg-gray-200 text-gray-800";
    let text = "Desconocido";
    if (status === "aprovado") {
      bgColor = "bg-green-100 text-green-800";
      text = "Aprobado";
    } else if (status === "confirmado") {
      bgColor = "bg-blue-100 text-blue-800";
      text = "Confirmado";
    } else if (status === "pendiente") {
      bgColor = "bg-yellow-100 text-yellow-800";
      text = "Pendiente";
    } else if (status === "cancelado") {
      bgColor = "bg-red-100 text-red-800";
      text = "Cancelado";
    }
    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor}`}
      >
        {text}
      </span>
    );
  };

  // Currency formatter
  const currencyFormatter = (params) => {
    if (params.value) {
      return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0,
      }).format(params.value);
    }
    return "$0";
  };

  // Instagram link renderer
  const InstagramCellRenderer = (params) => {
    return (
      <a
        href={`https://instagram.com/${params.value}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-aw-green/85 hover:text-aw-green hover:underline"
      >
        {params.value}
      </a>
    );
  };

  // Column definitions
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Nombre",
        field: "nombre",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          filterOptions: ["contains", "startsWith", "endsWith"],
          defaultOption: "startsWith",
        },
        minWidth: 180,
        cellStyle: { color: "hsl(72, 80%, 55%)" },
      },
      {
        headerName: "Instagram",
        field: "instagram",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          filterOptions: ["contains", "startsWith", "endsWith"],
          defaultOption: "startsWith",
        },
        cellRenderer: InstagramCellRenderer,
        maxWidth: 140,
      },
      {
        headerName: "Total Control",
        field: "totalControl",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 130,
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "Control Pagado",
        field: "controlPagado",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 140,
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "Invitación Free",
        field: "invitacionFree",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 130,
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "Invitación Con Descuento",
        field: "invitacionConDescuento",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 130,
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "Comisión",
        field: "comision",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        valueFormatter: currencyFormatter,
        width: 130,
        cellStyle: { textAlign: "right", fontWeight: "bold" },
      },
      {
        headerName: "Estado",
        field: "estado",
        sortable: true,
        filter: "agTextColumnFilter",
        editable: true,
        filterParams: {
          filterOptions: ["contains", "startsWith", "endsWith"],
          defaultOption: "startsWith",
        },
        cellRenderer: StatusCellRenderer,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: ["aprovado", "confirmado", "pendiente", "cancelado"],
        },
        width: 120,
        cellStyle: { textAlign: "center" },
      },
    ],
    []
  );

  // Grid options
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: false,
    }),
    []
  );

  return (
    <div className="w-full h-full">
      {/* Header */}
      <div className="pb-4 ">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-white">
              Estado del Staff
            </h2>
          </div>
          {/* <div className="flex items-center space-x-3">
            <button className="bg-aw-green scale-100 hover:scale-95 duration-300 text-aw-bluedark px-4 py-2 rounded-lg font-semibold transition">
              + Link Invitación
            </button>
          </div> */}
        </div>
      </div>

      {/* Data Grid */}
      <div className="">
        <div className="ag-theme-quartz w-full" style={{ height: "600px" }}>
          <AgGridReact
            rowData={rowData}
            // loading={loading}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
            // paginationPageSize={10}
            // rowSelection="multiple"
            // suppressMenuHide={true}
            // animateRows={true}
            // rowHeight={60}
            // headerHeight={50}
            // floatingFiltersHeight={40}
            // enableCellTextSelection={true}
            // rowClassRules={{
            //   'bg-green-50': (params) => params.data.estado === 'aprovado',
            //   'bg-blue-50': (params) => params.data.estado === 'confirmado',
            //   'bg-yellow-50': (params) => params.data.estado === 'pendiente',
            //   'bg-red-50': (params) => params.data.estado === 'cancelado'
            // }}
            // onGridReady={(params) => {
            //   params.api.sizeColumnsToFit()
            // }}
            // onFirstDataRendered={(params) => {
            //   params.api.sizeColumnsToFit()
            // }}
          />
        </div>
      </div>

      {/* Footer Stats */}
      <div className="px-6 py-4  bg-aw-bluedark-50">
        <div className="flex items-center justify-between text-sm text-gray-200">
          <div>
            Mostrando {rowData.length} registros de {rowData.length} total
          </div>
          <div className="flex items-center space-x-4">
            <div>
              Total Comisiones:{" "}
              {currencyFormatter({
                value: rowData.reduce((sum, row) => sum + row.comision, 0),
              })}
            </div>
            <div>
              Aprobados:{" "}
              {rowData.filter((row) => row.estado === "aprovado").length}
            </div>
            <div>
              Pendientes:{" "}
              {rowData.filter((row) => row.estado === "pendiente").length}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
